export enum ToolTypes {
  RELATIONSHIPS = 'RELATIONSHIPS',
  MINDSET = 'MINDSET',
  PHYSICALHEALTH = 'PHYSICALHEALTH',
  BRAINBOOSTERS = 'BRAINBOOSTERS',
  CAREGIVING = 'CAREGIVING',
  GUARDIAN = 'GUARDIAN',
  VIDEOS = 'VIDEOS',
}
